import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import ButtonTsoPq from '@components/Buttons/ButtonTsoPq';
import ModalDialogTsoPq from '@components/ModalDialog/ModalDialogTsoPq';
import TypographyTsoPq from '@components/Typography/TypographyTsoPq';
import { Box, styled } from '@mui/material';
import { useAppSelector } from '@redux/hooks';
import { setHasUnsavedChanges, setUnsavedChanges, upsertTableRow } from '@redux/slices/measurementVisualizationSlice';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

const StyledContent = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    width: '40.25rem',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_24,
    padding: `0 0 ${tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_24} 0`,
  };
});

const MeasurementVisualizationModal = () => {
  const [open, setOpen] = useState<boolean>(false);
  const row = useRef('');

  const { t } = useTranslation();
  const editingRow = useAppSelector((state) => state.measurementVisualization.editingRow) ?? '';
  const hasUnsavedChanges = useAppSelector((state) => state.measurementVisualization.hasUnsavedChanges) ?? false;
  const unsavedChanges = useAppSelector((state) => state.measurementVisualization.unsavedChanges) ?? undefined;

  const dispatch = useDispatch();

  useEffect(() => {
    if (row.current && editingRow) hasUnsavedChanges && setOpen(row.current !== editingRow);
    row.current = editingRow;
  }, [editingRow]);

  const handleDiscard = () => {
    dispatch(setUnsavedChanges(undefined));
    dispatch(setHasUnsavedChanges(false));
    setOpen(false);
  };

  const handleApplyChanges = () => {
    unsavedChanges && dispatch(upsertTableRow(unsavedChanges));
    setOpen(false);
  };

  return (
    <ModalDialogTsoPq
      modalState={open}
      buttons
      actions={
        <>
          <ButtonTsoPq buttonType="outlinedPrimary" textContent={t('general.label.discard')} onClick={handleDiscard} />
          <ButtonTsoPq buttonType="filledPrimary" textContent={t('general.label.apply')} onClick={handleApplyChanges} />
        </>
      }
    >
      <StyledContent>
        <TypographyTsoPq typographyType={'pageTitle'}>
          {t('measurementVisualization.parameters.modal.title')}
        </TypographyTsoPq>
        <TypographyTsoPq typographyType={'pageSubtitleMD'}>
          {t('measurementVisualization.parameters.modal.description')}
        </TypographyTsoPq>
      </StyledContent>
    </ModalDialogTsoPq>
  );
};

export default MeasurementVisualizationModal;
